import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import { deleteRecurringTask, updateTaskDetails } from '../../services/taskServices';
import {
  AssignGroup,
  AvatarImage,
  Deadline,
  Form,
  Group,
  Text as DetailTask,
  Label,
  ProjectName,
  ProjectTitle,
  Task,
  TaskContent,
  TaskItem,
  Tasklist,
  TaskHeader,
  Heading,
  Title,
  Menu,
  TaskIcons,
  Filter,
  DueDate,
  ProjectDate,
  SelectText,
  TaskTitle,
  MainTaskTitle,
  DropBlock,
  DotIcon,
  DropLabel,
  MultipleLabel,
  IconDueDate,
  HeaderTitle,
  Div,
  ButtonIcon,
  TooltipWrapper,
  SVGDiv,
  TooltipDiv,
  MainTooltipDiv,
  DropdownWrapper
} from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import Avatar from '../avatar';
import Linkify from 'react-linkify';
import { calculateDueTime, isEmpty } from '../../helpers/common';
import Button from '../button';
import AssignBoxV2 from '../dropdowns/assignPopup';
import { useTaskAssignActions } from '../dropdowns/assignPopup/assignActions';
import {
  AVATAR_BORDER,
  BUTTON_TYPE,
  EMPTY_STATE_SIZE,
  ICON_SIZE,
  LABEL_COLOUR_HASH,
  MY_TASKS_GROUP_FILTER_TYPE,
  MY_TASKS_GROUP_FILTER_TYPE_LABELS,
  STATUS_TYPE
} from '../../global/constants';
import Modal from '../modals/modal';
import { useParams } from 'react-router-dom';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import TaskLoading from '../loading/taskLoading';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { MobxMyTaskModelInterface } from '../../interfaces/TaskInterface';
import { updateUserWorkspacePreference } from '../../helpers/firebaseHelper';
import dayjs from 'dayjs';
import { captureException } from '../../services/logService';
import DeleteModal from '../modals/deleteModal';
import ConfirmationModal from '../modals/confirmationModal';
import { useMobileDevice } from '../../global/useMobile';
import { TASK_ANALYTICS } from '../../global/analyticsConstants';
import { Dropdown, DropdownItem } from '../dropdown';
import { menuItems } from '../../global/row';
import Tooltip from '../tooltip';
import MyCustomContextMenuV2 from '../customContextMenu';
import { TaskModel } from '../../mobx/models/task';
import { ProjectModel } from '../../mobx/models/project';
import TaskStatusDropdownV2 from '../dropdowns/taskStatusDropdown';
import PriorityDropDownV2 from '../dropdowns/priorityDropdown';
import { checkSubtaskStatus, onUpdateStatus, dispatchTaskUpdates } from '../../services/taskActionService';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import CreateTaskModalV2 from '../modals/createTaskModal';
import { TaskCount } from '../../pages/project/tasks/styles';
import ResponsiveHeader from '../responsiveHeader';
import BottomSubNavigation from '../bottomNavigation/subNavigation';
import BottomNavigationItem from '../bottomNavigation/subNavigation/bottomNavigationItem';
import EmptyStateV2 from '../emptyState';
import CheckboxInput from '../input/checkboxInput';
import { ROUTES } from '../../routes/urls';
interface Tasks {
  loading?: boolean;
  isMyTask?: boolean;
  loadData: () => void;
  data: MobxMyTaskModelInterface[];
  isMember?: boolean;
  memberId?: string;
  isRecurringTask?: boolean;
  myTasksFilter?: number;
}
interface AssignGroupComponentProps {
  onClickUsers: (taskId: string) => void;
  item: TaskModel;
  project: ProjectModel | undefined;
  loadData: () => void;
  isRecurringTask: boolean;
  className?: string;
  isMember?: boolean;
  isMyTask?: boolean;
}
const AssignGroupComponentBase: React.FC<AssignGroupComponentProps> = ({
  onClickUsers,
  item,
  project,
  className,
  isRecurringTask
}) => {
  const assignActions = useTaskAssignActions(item, { isRecurring: isRecurringTask });
  // Stabilize the context object so its identity tracks the task, not each render.
  // A fresh object every render defeats React.memo/observer in AssignBoxV2.
  const context = useMemo(
    () =>
      isRecurringTask
        ? { mode: 'recurringTask' as const, currentTask: item }
        : { mode: 'task' as const, currentTask: item },
    [isRecurringTask, item]
  );
  return (
    <AssignGroup className={className}>
      <ul role='button' onClick={() => onClickUsers(item?.id)}>
        {item?.users
          ?.filter((user) => !!user?.id)
          ?.map((user) => (
            <li key={user?.id}>
              <AvatarImage>
                <Avatar
                  imgSrc={user?.profile_photo || ''}
                  name={user?.name}
                  size={20}
                  borderVariant={AVATAR_BORDER.THIN}
                />
              </AvatarImage>
            </li>
          ))}
        <AssignBoxV2
          projectUsers={project?.users || []}
          context={context}
          onAssign={assignActions.onAssign}
          onUnassign={assignActions.onUnassign}
          isMultiAssignee={project?.multiAssignee}
        />
      </ul>
    </AssignGroup>
  );
};

// observer subscribes to item.usersIds so assign/unassign re-renders (incl. recurring tasks),
// while its built-in shallow-prop memo still skips unrelated parent re-renders.
export const AssignGroupComponent = observer(AssignGroupComponentBase);

// Shared stopPropagation handler to avoid allocating a new closure per row
const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

// Shared Linkify decorator to avoid creating a new function reference per row render
const linkDecorator = (decoratedHref: string, decoratedText: string, key: number) => (
  <a target='blank' href={decoratedHref} key={key}>
    {decoratedText}
  </a>
);

interface MyTaskRowProps {
  item: TaskModel;
  isActive: boolean;
  isMyTask?: boolean;
  isMember?: boolean;
  isRecurringTask?: boolean;
  maxVisibleLabels: number;
  loadData: () => void;
  onClickTaskDetails: (task: TaskModel) => void;
  onClickClone: (task: TaskModel) => void;
  onClickEdit: (task: TaskModel) => void;
  openDeleteModel: (task?: TaskModel) => void;
  onChangeStatus: (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => void;
  onClickTaskCheckBox: (task: TaskModel, status: boolean) => void;
  onClickUsers: (taskId: string) => void;
  onCLickProject: (projectId: string, e: React.SyntheticEvent) => void;
  setCurrentActiveTask: (taskId: string) => void;
}

const MyTaskRow: React.FC<MyTaskRowProps> = ({
  item,
  isActive,
  isMyTask,
  isMember,
  isRecurringTask,
  maxVisibleLabels,
  loadData,
  onClickTaskDetails,
  onClickClone,
  onClickEdit,
  openDeleteModel,
  onChangeStatus,
  onClickTaskCheckBox,
  onClickUsers,
  onCLickProject,
  setCurrentActiveTask
}) => {
  const { currentUser } = rootStore;

  // Read only for rows that show the due-date tooltip, so other rows don't re-render on format change.
  const dateFormat = item?.dueDate && !isRecurringTask ? currentUser?.dateFormat : undefined;

  // Recompute due-time and "Due on" label only when due date or date format changes.
  const dueResult = useMemo(
    () =>
      item?.dueDate
        ? { ...calculateDueTime(item.dueDate), dueOnLabel: dayjs(item.dueDate).format(dateFormat) }
        : undefined,
    [item?.dueDate, dateFormat]
  );

  // Completed subtask count for this row only
  const completedSubtasksCount = useMemo(
    () => item?.subTasks?.filter((subTask) => subTask?.status)?.length,
    [item?.subTasks]
  );

  // Overflow ("+N more") tooltip content — rebuilt only when labels or the visible count change
  const labelOverflowTooltip = useMemo(() => {
    const overflowLabels = item?.labels?.slice(maxVisibleLabels) ?? [];
    if (overflowLabels.length === 0) return null;
    return (
      <MainTooltipDiv>
        {overflowLabels.map((l) => (
          <TooltipDiv key={l.id}>
            <DotIcon color={`${LABEL_COLOUR_HASH[l.color]}`} />
            <span>{l.name}</span>
          </TooltipDiv>
        ))}
      </MainTooltipDiv>
    );
  }, [item?.labels, maxVisibleLabels]);

  // Memoized per-row handlers — stable references keep child dropdowns/menus from re-rendering
  const handleClickDetails = useCallback(() => onClickTaskDetails(item), [onClickTaskDetails, item]);

  const handleUpdateStatus = useCallback(
    (status: StatusListInterface, previousStatus: StatusListInterface) => onChangeStatus(item, status, previousStatus),
    [onChangeStatus, item]
  );

  const handleCheckboxChange = useCallback(
    () => !isRecurringTask && onClickTaskCheckBox(item, !item?.status),
    [isRecurringTask, onClickTaskCheckBox, item]
  );

  const handleClickProject = useCallback(
    (e: React.SyntheticEvent) => onCLickProject(item?.projectId, e),
    [onCLickProject, item]
  );

  return (
    <MyCustomContextMenuV2
      taskData={item}
      loadData={loadData}
      currentProject={item?.project!}
      setCurrentActiveTask={setCurrentActiveTask}
      onClickView={onClickTaskDetails}
      onClickClone={onClickClone}
      onClickEdit={onClickEdit}
      onClickDelete={openDeleteModel}
      statusList={item.project?.statusData || []}
      isMyTask={isMyTask}
      isMember={isMember}
      isRecurringTask={isRecurringTask}
      onUpdateStatus={onChangeStatus}
      isSubTask={!!item?.parentTaskId}>
      <TaskContent
        role='button'
        onClick={handleClickDetails}
        isActive={isActive}
        className={item?.subTasks ? 'task-item' : ''}>
        <TaskItem>
          <Form isTaskItem={true}>
            <DropdownWrapper>
              {(item?.statusId || item?.statusDetails?.['_id']) && item?.project?.statusEnable && !isRecurringTask ? (
                <TaskStatusDropdownV2
                  defaultStatus={item?.project?.defaultStatus}
                  statusList={item?.project?.statusData || []}
                  currentStatusId={item?.statusId}
                  isTaskCheckBox={true}
                  onUpdateStatus={handleUpdateStatus}
                  isIconButton={true}
                />
              ) : (
                <ButtonIcon>
                  <CheckboxInput
                    onClick={stopPropagation}
                    onChange={handleCheckboxChange}
                    checked={item?.status}
                    checkboxType='task-checkbox'
                  />
                </ButtonIcon>
              )}
              <PriorityDropDownV2
                taskData={item}
                currentProject={item?.project!}
                isTaskCheckBox={true}
                isIconButton={true}
                isRecurringTask={isRecurringTask}
              />
            </DropdownWrapper>
            <Linkify componentDecorator={linkDecorator}>
              {isEmpty(item?.parentTaskId) ? (
                <Label isMainTask>{item?.name}</Label>
              ) : (
                <TaskTitle role='button' onClick={handleClickDetails}>
                  <Label>{item?.name}</Label>
                  <SVGDiv>
                    <SVGIcon
                      name='updated-large-right-arrow-icon'
                      width={ICON_SIZE.XS}
                      height={ICON_SIZE.XS}
                      viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                      fill='var(--text-secondary)'
                    />
                  </SVGDiv>
                  <MainTaskTitle>{item?.parentTask?.name || ''}</MainTaskTitle>
                </TaskTitle>
              )}
            </Linkify>
            {item?.subTasks && item?.subTasks?.length > 0 && (
              <TaskCount>
                {completedSubtasksCount}/{item?.subTasks?.length}
              </TaskCount>
            )}
          </Form>
          <AssignGroupComponent
            className='assign'
            onClickUsers={onClickUsers}
            item={item}
            project={item?.project!}
            loadData={loadData}
            isRecurringTask={isRecurringTask || false}
            isMember={isMember}
            isMyTask={isMyTask}
          />
        </TaskItem>
        <Deadline>
          <AssignGroupComponent
            className='resp-assign'
            onClickUsers={onClickUsers}
            item={item}
            project={item?.project!}
            loadData={loadData}
            isRecurringTask={isRecurringTask || false}
            isMember={isMember}
            isMyTask={isMyTask}
          />

          {item?.labels?.length > 0 && (
            <MultipleLabel>
              {item?.labels?.map((label, index) => {
                if (index < maxVisibleLabels) {
                  return (
                    <DropBlock className={index === 0 ? 'left-border' : ''} key={label?.id}>
                      <DotIcon color={`${LABEL_COLOUR_HASH[label?.color]}`} />
                      <DropLabel>{label?.name}</DropLabel>
                    </DropBlock>
                  );
                } else if (index === maxVisibleLabels) {
                  const remainingLabels = item.labels.length - maxVisibleLabels;
                  if (remainingLabels > 0) {
                    return (
                      <Tooltip title={labelOverflowTooltip} maxWidth='max-content' key={label?.id}>
                        <DropBlock>
                          <DropLabel>+{remainingLabels} more</DropLabel>
                        </DropBlock>
                      </Tooltip>
                    );
                  }
                }
                return null;
              })}
            </MultipleLabel>
          )}
          <ProjectDate>
            <ProjectName
              role='button'
              isRecurringTask={isRecurringTask}
              showRightBorder={!!item?.dueDate}
              onClick={handleClickProject}>
              <p>{item?.project?.name}</p>
            </ProjectName>
            <DueDate>
              {item?.dueDate && !isRecurringTask && (
                <>
                  <Tooltip
                    title={
                      <>
                        <div>Due {dueResult?.dueParam}</div>
                        <div> Due on {dueResult?.dueOnLabel}</div>
                      </>
                    }
                    placement='bottom'
                    maxWidth={'max-content'}>
                    <TooltipWrapper>
                      <DetailTask isOverdue={dueResult?.overDue}> {dueResult?.dueTime} </DetailTask>
                      <IconDueDate role='button' className='calendar-icon' onClick={stopPropagation}>
                        {dueResult?.overDue && !item?.status ? (
                          <SVGIcon
                            name='tasklist-calendar-duedate-icon'
                            width={ICON_SIZE.XXL}
                            height={ICON_SIZE.XXL}
                            viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
                            className='calendar-due-fill-color'
                          />
                        ) : (
                          <SVGIcon
                            name='tasklist-calendar-icon'
                            width={ICON_SIZE.XXL}
                            height={ICON_SIZE.XXL}
                            viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
                            className='calendar-fill-color'
                          />
                        )}
                      </IconDueDate>
                    </TooltipWrapper>
                  </Tooltip>
                </>
              )}
            </DueDate>
          </ProjectDate>
        </Deadline>
      </TaskContent>
    </MyCustomContextMenuV2>
  );
};

// Mirror the areEqual pattern used by the project TaskItem: only re-render this row
// when one of the props it actually renders from changes. Handler props are stable
// (useCallback in the parent) so they are intentionally not compared here.
const areEqual = (prev: MyTaskRowProps, next: MyTaskRowProps) => {
  if (prev.item?.id !== next.item?.id) return false;
  if (prev.isActive !== next.isActive) return false;
  if (prev.isMyTask !== next.isMyTask) return false;
  if (prev.isMember !== next.isMember) return false;
  if (prev.isRecurringTask !== next.isRecurringTask) return false;
  if (prev.maxVisibleLabels !== next.maxVisibleLabels) return false;
  return true;
};

const MyTaskRowMemo = React.memo(observer(MyTaskRow), areEqual);

// eslint-disable-next-line @typescript-eslint/no-redeclare
const Tasks: React.FC<Tasks> = (props) => {
  const { loading, isMyTask, loadData, data, isMember, isRecurringTask, myTasksFilter } = props;
  //State
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<TaskModel>();
  const [currentActiveTask, setCurrentActiveTask] = useState<string>('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [currentTask, setCurrentTask] = useState<TaskModel>();
  const [isConfirmationModelOpen, setIsConfirmationModelOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [status, setStatus] = useState<StatusListInterface>();
  const [previousStatus, setPreviousStatus] = useState<StatusListInterface>();
  const [editData, setEditData] = useState<TaskModel>();
  const [openCreateTask, setOpenCreateTask] = useState(false);
  const [maxVisibleLabels, setMaxVisibleLabels] = useState(3);

  //Mobx store variable
  const { workspaceStore, currentUser } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;

  //Other variable
  const params: { id: string } = useParams();
  const memberDetail = workspace?.users?.find((x: { id: string }) => x?.id === params?.id);
  const mobile = useMobileDevice();
  const history = useHistory();

  const openCreateTaskModal = useCallback(async () => {
    if (isMyTask) {
      if (currentUser) rootStore.taskStore.createTaskInput.addAssignee(currentUser?.id);
    }
    setOpenCreateTask(true);
  }, [isMyTask, currentUser]);

  const closeCreateTaskModal = useCallback(() => {
    setOpenCreateTask(false);
  }, []);

  const handleOpenConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(true);
  }, []);

  const closeConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(false);
  }, []);

  const onCLickProject = useCallback(
    (projectId: string, e: React.SyntheticEvent) => {
      e.stopPropagation();
      history.push(ROUTES.PROJECT_TASKS.replace(':id', projectId || ''));
    },
    [history]
  );

  const onClickEdit = useCallback(
    async (item: TaskModel) => {
      setEditData(item);
      if (isRecurringTask) {
        rootStore.taskStore.createTaskInput.updateWith(item);
      } else {
        rootStore.taskStore.createTaskInput.updateWith(item);
      }
      setOpenCreateTask(true);
    },
    [isRecurringTask]
  );

  const onClickClone = useCallback(async (item: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(item);
    rootStore.taskStore.createTaskInput.setDueDate(null);
    rootStore.taskStore.createTaskInput.setId(undefined);
    // Set cloneTaskId if the task has subtasks
    if (item.subTasks && item.subTasks.length > 0) {
      rootStore.taskStore.createTaskInput.setCloneTaskId(item.id);
    }
    setOpenCreateTask(true);
  }, []);

  const onChangeGroupByFilter = useCallback(async (key: number | string) => {
    key = Number(key);
    rootStore.taskStore.setMyTasksFilter(key);
    // Update my tasks filter in workspace preference
    await updateUserWorkspacePreference({ my_task_filter: { group_by: key } });
  }, []);

  const openDeleteModel = useCallback((task?: TaskModel) => {
    if (task) setSelectedItem(task);
    setDeleteModelOpen(true);
  }, []);

  const deleteTask = useCallback(
    async (task: TaskModel) => {
      try {
        setDeleteLoading(true);
        if (!isRecurringTask) {
          const payloadTask = { isArchived: true, projectId: task?.projectId };
          const response = await updateTaskDetails(task?.id, payloadTask);
          setDeleteModelOpen(false);
          if (response) {
            rootStore.taskStore.removeTasks([task?.id]);
          }
        } else {
          const response = await deleteRecurringTask(task?.id, task?.projectId);
          if (response) {
            rootStore.taskStore.removeRecurringTasks([task?.id]);
            setDeleteModelOpen(false);
          }
        }
      } catch (e) {
        captureException(e);
      } finally {
        setDeleteLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const close = () => {
    setDeleteModelOpen(false);
  };

  const onChangeStatus = useCallback(
    (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status.Type === STATUS_TYPE.COMPLETED && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setStatus(status);
        setPreviousStatus(previousStatus);
        setCurrentTask(task);
        return;
      }
      onUpdateStatus(task, status, previousStatus, false);
    },
    [handleOpenConfirmationModal]
  );

  //Handle checkbox click when project status is disabled
  const onClickTaskCheckBox = useCallback(
    (task: TaskModel, status: boolean) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setCurrentTask(task);
        return;
      }
      task.setStatus(status, false);
      dispatchTaskUpdates(task, status);
    },
    [handleOpenConfirmationModal]
  );

  //Handle Yes button click for confirmation model
  const onClickConfirm = useCallback(() => {
    if (!currentTask) return;
    try {
      setConfirmationLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, true);
      } else {
        currentTask.setStatus(true, true);
        dispatchTaskUpdates(currentTask, true);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setConfirmationLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, previousStatus, status]);

  //Handle No button click for confirmation model
  const onClickNo = useCallback(() => {
    if (!currentTask) return;
    try {
      setCancelLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, false);
      } else {
        currentTask.setStatus(true, false);
        dispatchTaskUpdates(currentTask, true);
      }
    } catch (error) {
    } finally {
      setCancelLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, previousStatus, status]);

  // logic for show task details
  const onClickTaskDetails = useCallback(
    (task: TaskModel) => {
      if (isRecurringTask) {
        return;
      }
      const eventProperties = {
        source: 'task list',
        title: task?.name || ''
      };
      trackAnalyticActivity(TASK_ANALYTICS.VIEW, eventProperties);
      rootStore.taskStore.setCurrentTask(task?.id);
      history.push(ROUTES.TASK_DETAILS.replace(':id', task?.projectId || '').replace(':taskId', task?.id || ''));
    },
    [history, isRecurringTask]
  );

  const onClickUsers = useCallback(
    (taskId: string) => {
      if (mobile) {
        rootStore.taskStore.setCurrentAssignBoxTaskId(taskId);
      }
    },
    [mobile]
  );

  const MenuItemDropdown = useMemo(() => {
    return menuItems.map((item) => (
      <DropdownItem label={item.label} key={item.key} onClick={() => onChangeGroupByFilter(item.key)} />
    ));
  }, [onChangeGroupByFilter]);

  useEffect(() => {
    const updateLabelLimit = () => {
      setMaxVisibleLabels(window.innerWidth > 1024 ? 4 : 3);
    };

    updateLabelLimit(); // Initial check
    window.addEventListener('resize', updateLabelLimit);
    return () => window.removeEventListener('resize', updateLabelLimit);
  }, []);

  const TaskFilter = useMemo(() => {
    let taskFilter = myTasksFilter;
    if (taskFilter === MY_TASKS_GROUP_FILTER_TYPE.GROUP) {
      taskFilter = MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE;
    }
    return (
      data?.length > 0 &&
      data[0]?.tasks?.length > 0 && (
        <TaskIcons>
          <Filter isHide={myTasksFilter === MY_TASKS_GROUP_FILTER_TYPE.NONE}>
            <SVGIcon
              name='small-filter-updated-icon'
              width={ICON_SIZE.SM}
              height={ICON_SIZE.SM}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-primary)'
            />
            {!mobile && (
              <SelectText isHide={myTasksFilter === MY_TASKS_GROUP_FILTER_TYPE.NONE}>
                {MY_TASKS_GROUP_FILTER_TYPE_LABELS[taskFilter || MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE] || ''}
              </SelectText>
            )}
          </Filter>
        </TaskIcons>
      )
    );
  }, [data, mobile, myTasksFilter]);

  const renderFilterDropdown = useCallback(() => {
    return (
      <Dropdown modalTitle='Group By' content={TaskFilter} trigger='click'>
        {MenuItemDropdown}
      </Dropdown>
    );
  }, [MenuItemDropdown, TaskFilter]);

  const showEmptyState = !loading && (data?.length === 0 || data[0]?.tasks?.length === 0);

  return (
    <>
      {isMyTask && (
        <>
          {!mobile ? (
            <TaskHeader>
              <HeaderTitle>
                <Heading>
                  <Title>{isRecurringTask ? 'Recurring Tasks' : 'My Tasks'}</Title>
                </Heading>
              </HeaderTitle>
              {!isRecurringTask && (
                <Menu>
                  {renderFilterDropdown()}
                  {/* hides button in responsive screen and calls responsive button */}
                  <div>
                    {data?.length > 0 && data[0]?.tasks?.length > 0 && (
                      <Button
                        title='New Task'
                        iconName='plus-icon'
                        variant={BUTTON_TYPE.PRIMARY}
                        size='small'
                        iconPosition='start'
                        onClick={openCreateTaskModal}
                      />
                    )}
                  </div>
                </Menu>
              )}
            </TaskHeader>
          ) : (
            <ResponsiveHeader
              title={isRecurringTask ? 'Recurring Tasks' : 'My Tasks'}
              leftElement={renderFilterDropdown()}
              noMargin={true}
            />
          )}
        </>
      )}
      <Group
        isEmptyState={showEmptyState}
        className={showEmptyState ? 'project-message-detail' : ''}
        isMember={isMember}>
        {loading && (data?.length === 0 || !data) && <TaskLoading isMarginTop={true} isMember={isMember} />}
        {showEmptyState && (
          <EmptyStateV2
            size={EMPTY_STATE_SIZE.MEDIUM}
            title={`${isMember ? memberDetail?.name : 'You'} have no ${isRecurringTask ? 'Recurring' : ''} Tasks ${
              !isRecurringTask ? 'Assigned' : ''
            }`}
            description={isRecurringTask ? '' : 'You can add New task by clicking the button below'}
            imageUrl='mytask_empty'
            onClick={!isRecurringTask ? openCreateTaskModal : undefined}
            buttonTitle={!isRecurringTask ? 'New Task' : undefined}
            isAlignedCenter={true}
          />
        )}

        {data?.length > 0 && data[0]?.tasks?.length > 0 && (
          <Div>
            {data?.length > 0 &&
              data[0]?.tasks?.length > 0 &&
              data?.map((group, index: number) => {
                return (
                  <Task key={group?.title} isMember={isMember}>
                    {myTasksFilter !== MY_TASKS_GROUP_FILTER_TYPE.NONE && (
                      <Tasklist>
                        <ProjectTitle>{!isEmpty(group?.title) ? group?.title : ''}</ProjectTitle>
                      </Tasklist>
                    )}
                    {group?.tasks?.map((item) => (
                      <MyTaskRowMemo
                        key={item?.id}
                        item={item}
                        isActive={currentActiveTask === item?.id}
                        isMyTask={isMyTask}
                        isMember={isMember}
                        isRecurringTask={isRecurringTask}
                        maxVisibleLabels={maxVisibleLabels}
                        loadData={loadData}
                        onClickTaskDetails={onClickTaskDetails}
                        onClickClone={onClickClone}
                        onClickEdit={onClickEdit}
                        openDeleteModel={openDeleteModel}
                        onChangeStatus={onChangeStatus}
                        onClickTaskCheckBox={onClickTaskCheckBox}
                        onClickUsers={onClickUsers}
                        onCLickProject={onCLickProject}
                        setCurrentActiveTask={setCurrentActiveTask}
                      />
                    ))}
                  </Task>
                );
              })}
          </Div>
        )}
        <Modal open={openCreateTask} maxWidth={'680px'} onClose={closeCreateTaskModal} isCreateTask={true}>
          <CreateTaskModalV2
            loadData={loadData}
            onCancel={closeCreateTaskModal}
            context={isRecurringTask ? { source: 'recurring', task: editData! } : { source: 'myTask', task: editData }}
          />
        </Modal>
        <Modal open={deleteModelOpen} onClose={close} maxWidth={'334px'}>
          <DeleteModal
            onClose={close}
            onOk={() => selectedItem && deleteTask(selectedItem)}
            loading={deleteLoading}
            modalTitle={`${
              (selectedItem?.subTasks?.length ?? 0) > 0
                ? `Delete this task and ${selectedItem?.subTasks?.length} subtasks?`
                : 'Delete Task?'
            }`}
            description={`${
              (selectedItem?.subTasks?.length ?? 0) > 0
                ? 'This action will remove this task and all its connected subtasks.'
                : 'Are you sure you want to delete this task?'
            }`}
          />
        </Modal>
        <Modal open={isConfirmationModelOpen} onClose={closeConfirmationModal} maxWidth={'334px'}>
          <ConfirmationModal
            loading={confirmationLoading}
            cancelLoading={cancelLoading}
            onOk={onClickConfirm}
            onNo={onClickNo}
            onClose={closeConfirmationModal}
            modalTitle='Uncompleted Subtasks'
            description='Do you want to complete all these subtasks?'
          />
        </Modal>
        <BottomSubNavigation
          rightElement={
            data?.length > 0 &&
            data[0]?.tasks?.length > 0 && (
              <BottomNavigationItem iconName={!isRecurringTask ? 'plus-icon' : ''} onClick={openCreateTaskModal} />
            )
          }
        />
      </Group>
    </>
  );
};

export default observer(Tasks);
